import React from 'react';
import {Field, useField} from 'formik';
import classnames from 'classnames';

const DataItemCheckbox = ({
                            fieldName,
                            label,
                            containerClassname = '',
                            containerStyles = {},
                            labelClassname = '',
                            inputClassname = '',
                            checkboxSize = '',
                            disabled,
                            ...rest
                          }) => {

  return (
    <Field name={fieldName}>
      {({field}) => (
        <div style={containerStyles} className={classnames(`h-24px`, containerClassname, {'opacity-30': disabled})}>
          <div className={classnames(`text-nowrap font-size-lg mx-2`, labelClassname)}>
            {label}
          </div>
          <input
            className={classnames(`d-none custom-grid-checkbox`, inputClassname)}
            type="checkbox"
            checked={field.value}
            id={fieldName}
            disabled={disabled}
            {...field}
            {...rest}
          />
          <label
            htmlFor={fieldName}
            className={classnames(`custom-checkbox mb-0 custom-checkbox-size`, checkboxSize)}
          />
        </div>
      )}
    </Field>
  );
};

export const FieldDataItemCheckboxFixed = ({
                                             name,
                                             label,
                                             containerClassname = '',
                                             containerStyles = {},
                                             labelClassname = '',
                                             inputClassname = '',
                                             checkboxSize = '',
                                             disabled,
                                             onChange,
                                             ...rest
                                           }) => {
  const [field] = useField({name, type: 'checkbox'});
  return (
    <div style={containerStyles} className={classnames(`h-24px`, containerClassname, {'opacity-30': disabled})}>
      <div className={classnames(`text-nowrap custom-brand-color font-size-lg`, labelClassname)}>
        {label}
      </div>
      <input
        className={classnames(`d-none custom-grid-checkbox`, inputClassname)}
        type="checkbox"
        id={name}
        disabled={disabled}
        {...field}
        onChange={(e) => {
          field.onChange(e);
          if (onChange) {
            onChange(e);
          }
        }}
        {...rest}
      />
      <label
        htmlFor={name}
        className={classnames(`custom-checkbox mb-0 custom-checkbox-size`, checkboxSize)}
      />
    </div>
  );
};

export default DataItemCheckbox;
